/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { DataTableModule, CheckboxModule, TreeTableModule} from 'primeng/primeng'
import {TableModule} from 'primeng/table';

import { AppRoutingModule } from './../app-routing.module';
import { CommonService} from './../common.service'
import { WaterSystemsComponent } from './water-systems.component';
import { MapModule } from '../map-pws/map.module'
import { HeaderModule } from './../header/header.module'
import { LocationModule } from './../location/location.module'
import { AccordionCustomModule } from './accordian'

@NgModule({
  declarations: [WaterSystemsComponent],
  imports: [BrowserModule,CommonModule,FormsModule,BrowserAnimationsModule, DataTableModule,
    CheckboxModule, AppRoutingModule,MapModule, AccordionCustomModule,HeaderModule, TreeTableModule,TableModule, LocationModule],
  providers: [CommonService],
  exports: []
})

export class WaterSystemsModule { }
